import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({
  children,
  adminOnly = false,
  fiscalOnly = false,
  visualizadorOnly = false
}) => {
  const { user, loading } = useAuth();

  if (loading) {
    return <div style={{
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      height: '100vh'
    }}>Carregando...</div>;
  }

  if (!user) {
    return <Navigate to="/login" />;
  }

  // Redirecionar baseado no papel do usuário
  const getRoleBasedRedirect = () => {
    if (user.role === 'admin') return '/admin/dashboard';
    if (user.role === 'fiscal') return '/fiscal/dashboard';
    if (user.role === 'visualizador') return '/visualizador/dashboard';
    return '/user/dashboard';
  };

  if (adminOnly && user.role !== 'admin') {
    return <Navigate to={getRoleBasedRedirect()} />;
  }

  if (fiscalOnly && user.role !== 'fiscal') {
    return <Navigate to={getRoleBasedRedirect()} />;
  }

  if (visualizadorOnly && user.role !== 'visualizador') {
    return <Navigate to={getRoleBasedRedirect()} />;
  }

  return children;
};

export default PrivateRoute;
